// extracted by mini-css-extract-plugin
module.exports = {"ConfirmPlace":"ConfirmPlace_ConfirmPlace__s2vNW"};